import { useMutation } from '@tanstack/vue-query';
import { baseApi } from '../baseApi';
import { useLazyQuery } from '../useLazyQuery';
import {
  type FindPairsRequest,
  type FindPairsResponse,
  type SetPairsRequest,
  type SetPairsResponse,
  type PairAlarmingRequest,
  type PairAlarmingResponse
} from './types';

export const useLazyFindPairs = () => useLazyQuery<FindPairsResponse, FindPairsRequest>({
  queryKey: (params) => {
    const keys = ['find-pairs'];
    
    if (params?.epces) {
      keys.push(...params.epces);
    }

    if (params?.cises) {
      keys.push(...params.cises);
    }

    return keys;
  },
  queryFn: (params) => baseApi<FindPairsResponse, FindPairsRequest>({ url: '/api/m/pair/v2/find', method: 'POST', body: params  }),
  staleTime: 0
});

export const useSetPairs = () => useMutation({
  mutationFn: (body: SetPairsRequest) =>
    baseApi<SetPairsResponse, SetPairsRequest>({
      url: '/api/m/pair/v2/set',
      method: 'POST',
      body
    })
});

export const setPairs = (body: SetPairsRequest) => baseApi<SetPairsResponse, SetPairsRequest>({
  url: '/api/m/pair/v2/set',
  method: 'POST',
  body
});

export const useLazyGetPairAlarm = () => useLazyQuery<PairAlarmingResponse, PairAlarmingRequest>({
  queryKey: (params) => ['pair-alarm', params?.epc],
  queryFn: (params) => baseApi<PairAlarmingResponse, PairAlarmingRequest>({ url: '/api/m/pair/alarm', method: 'POST', body: params  }),
  staleTime: 0
});